// AIR-BUDDY-3D: היועץ הירוק בתלת־ממד. נטען רק כשהאזור מתקרב למסך; אם אין תמיכה, נשאר הציור הקיים.
(function () {
  const art = document.querySelector('.aqc-art');
  if (!art || art.dataset.b3d) return; art.dataset.b3d = '1';
  const svg = art.querySelector('svg'); if (!svg) return;
  const t = document.createElement('canvas');
  if (!(t.getContext('webgl2') || t.getContext('webgl'))) return;

  const start = async () => {
    let THREE, OutlineEffect;
    try {
      const base = art.dataset.b3dBase; if (!base) return;
      THREE = await import(base + 'b3d-three.min.js');
      ({ OutlineEffect } = await import(base + 'b3d-outline.js'));
    } catch (e) { return; }

    // שכבת הקנבס יושבת בדיוק על ה-SVG; העיגול, הבועה והנקודה נשארים מה-SVG
    art.style.position = 'relative';
    const box = document.createElement('div');
    box.className = 'aqc-3d';
    box.style.cssText = 'position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);aspect-ratio:1/1;cursor:pointer;touch-action:manipulation;z-index:2';
    const fit = () => { const r = svg.getBoundingClientRect(); box.style.width = r.width + 'px'; };
    art.appendChild(box); fit();

    const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    const small = innerWidth < 768;
    const renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
    renderer.setPixelRatio(Math.min(devicePixelRatio, small ? 1.5 : 2));
    renderer.outputColorSpace = THREE.SRGBColorSpace;
    renderer.domElement.style.cssText = 'width:100%;height:100%;display:block';
    box.appendChild(renderer.domElement);
    const effect = new OutlineEffect(renderer, { defaultThickness: 0.0075, defaultColor: [0.10, 0.10, 0.086], defaultAlpha: 1 });

    const scene = new THREE.Scene();
    const camera = new THREE.PerspectiveCamera(30, 1, 0.1, 50);
    camera.position.set(0, 0.95, 11.4); camera.lookAt(0, 0.8, 0);
    scene.add(new THREE.HemisphereLight(0xFFF8E8, 0x9DB394, 1.15));
    const key = new THREE.DirectionalLight(0xFFFFFF, 1.55); key.position.set(-3, 5, 6); scene.add(key);
    const rim = new THREE.DirectionalLight(0xE8F2DC, 1.4); rim.position.set(2, 3, -5); scene.add(rim);

    const gm = new THREE.DataTexture(new Uint8Array([90, 90, 90, 255, 185, 185, 185, 255, 255, 255, 255, 255]), 3, 1);
    gm.minFilter = gm.magFilter = THREE.NearestFilter; gm.needsUpdate = true;
    const toon = (color, extra = {}) => new THREE.MeshToonMaterial({ color, gradientMap: gm, ...extra });

    function trichomeTex() {
      const c = document.createElement('canvas'); c.width = c.height = 256; const x = c.getContext('2d');
      x.fillStyle = '#fff'; x.fillRect(0, 0, 256, 256);
      let s = 7; const r = () => (s = (s * 16807) % 2147483647) / 2147483647;
      for (let i = 0; i < 2600; i++) { const g = 215 + r() * 40 | 0; x.fillStyle = `rgb(${g},${Math.min(255, g + 3)},${g})`; x.fillRect(r() * 256, r() * 256, 1.4, 1.4); }
      const tx = new THREE.CanvasTexture(c); tx.wrapS = tx.wrapT = THREE.RepeatWrapping; tx.repeat.set(1, 3); tx.colorSpace = THREE.SRGBColorSpace; return tx;
    }
    const leafMat = toon(0xFFFFFF, { vertexColors: true, side: THREE.DoubleSide, map: trichomeTex() });

    function leafGeometry(len, wid, curl, twist) {
      const NU = 24, NV = 4, pos = [], col = [], uv = [], idx = [];
      const base = new THREE.Color(0x4F6B4B), mid = new THREE.Color(0xA9C8A0), tip = new THREE.Color(0xCFE3C6);
      let p = new THREE.Vector3(), ang = 0; const step = len / NU; const spine = [];
      for (let i = 0; i <= NU; i++) { const u = i / NU; spine.push({ p: p.clone(), ang }); ang = curl * Math.pow(u, 1.35); p.add(new THREE.Vector3(0, Math.cos(ang) * step, Math.sin(ang) * step)); }
      for (let i = 0; i <= NU; i++) {
        const u = i / NU, { p: sp, ang: a } = spine[i];
        const w = wid * Math.pow(1 - u, 0.6) * Math.min(1, u / 0.1 + 0.55);
        const n = new THREE.Vector3(0, -Math.sin(a), Math.cos(a)); const tw = twist * u;
        for (let j = 0; j <= NV; j++) {
          const v = j / NV * 2 - 1;
          const side = new THREE.Vector3(Math.cos(tw), 0, 0).addScaledVector(n, Math.sin(tw));
          const q = sp.clone().addScaledVector(side, v * w).addScaledVector(n, -Math.abs(v) * w * 0.45 + w * 0.2);
          pos.push(q.x, q.y, q.z);
          const c = u < 0.45 ? base.clone().lerp(mid, u / 0.45) : mid.clone().lerp(tip, (u - 0.45) / 0.55);
          col.push(c.r, c.g, c.b); uv.push(j / NV, u);
        }
      }
      for (let i = 0; i < NU; i++) for (let j = 0; j < NV; j++) { const a = i * (NV + 1) + j, b = a + NV + 1; idx.push(a, b, a + 1, b, b + 1, a + 1); }
      const g = new THREE.BufferGeometry();
      g.setAttribute('position', new THREE.Float32BufferAttribute(pos, 3));
      g.setAttribute('color', new THREE.Float32BufferAttribute(col, 3));
      g.setAttribute('uv', new THREE.Float32BufferAttribute(uv, 2));
      g.setIndex(idx); g.computeVertexNormals(); return g;
    }

    const buddy = new THREE.Group(); scene.add(buddy);
    const head = new THREE.Group(); buddy.add(head);
    const face = new THREE.Mesh(new THREE.SphereGeometry(1, 64, 48), toon(0xD6E8CE)); face.scale.set(1.04, 0.94, 0.98); head.add(face);
    const eyeMat = new THREE.MeshToonMaterial({ color: 0x1D1D19, gradientMap: gm });
    const glint = new THREE.MeshBasicMaterial({ color: 0xFFFFFF });
    const eyes = [], happy = [];
    for (const sx of [-1, 1]) {
      const g = new THREE.Group(); g.position.set(sx * 0.33, -0.02, 0.9); g.lookAt(sx * 0.33, -0.02, 3);
      const e = new THREE.Mesh(new THREE.SphereGeometry(0.135, 32, 24), eyeMat); e.scale.set(0.92, 1.12, 0.55); g.add(e);
      const s1 = new THREE.Mesh(new THREE.SphereGeometry(0.042, 16, 12), glint); s1.position.set(-0.045, 0.055, 0.07); g.add(s1);
      const s2 = new THREE.Mesh(new THREE.SphereGeometry(0.02, 12, 8), glint); s2.position.set(0.04, -0.04, 0.07); g.add(s2);
      head.add(g); eyes.push(g);
      const arc = new THREE.Mesh(new THREE.TorusGeometry(0.11, 0.028, 8, 24, Math.PI), eyeMat);
      arc.position.set(sx * 0.33, -0.05, 0.93); arc.visible = false; head.add(arc); happy.push(arc);
    }
    const blushMat = new THREE.MeshBasicMaterial({ color: 0xF3A99D, transparent: true, opacity: 0.55, depthWrite: false });
    for (const sx of [-1, 1]) { const b = new THREE.Mesh(new THREE.CircleGeometry(0.15, 32), blushMat); b.scale.set(1.25, 0.8, 1); b.position.set(sx * 0.56, -0.25, 0.79); b.lookAt(sx * 1.4, -0.6, 2.6); b.userData.outlineParameters = { visible: false }; head.add(b); }
    const smileCurve = new THREE.QuadraticBezierCurve3(new THREE.Vector3(-0.13, -0.27, 0.925), new THREE.Vector3(0, -0.4, 0.93), new THREE.Vector3(0.13, -0.27, 0.925));
    head.add(new THREE.Mesh(new THREE.TubeGeometry(smileCurve, 20, 0.022, 8), eyeMat));
    const phoneMat = toon(0x3A3A31), padMat = toon(0x55554A);
    const band = new THREE.Mesh(new THREE.TorusGeometry(1.17, 0.075, 16, 64, Math.PI), phoneMat); band.position.y = 0.02; head.add(band);
    for (const sx of [-1, 1]) {
      const cup = new THREE.Group(); cup.position.set(sx * 1.06, -0.02, 0); cup.rotation.z = Math.PI / 2;
      cup.add(new THREE.Mesh(new THREE.CylinderGeometry(0.3, 0.32, 0.26, 40), phoneMat));
      const pad = new THREE.Mesh(new THREE.TorusGeometry(0.25, 0.07, 12, 32), padMat); pad.rotation.x = Math.PI / 2; pad.position.y = -sx * 0.14; cup.add(pad);
      const cap = new THREE.Mesh(new THREE.CylinderGeometry(0.17, 0.17, 0.04, 32), toon(0xC0D8C0)); cap.position.y = sx * 0.14; cup.add(cap);
      head.add(cup);
    }
    let seed = 11; const rnd = () => (seed = (seed * 16807) % 2147483647) / 2147483647;
    const R = (a, b) => a + (b - a) * rnd();
    const leaves = [];
    function ring(n, pr, lr, wr, tr, cr, front) {
      for (let i = 0; i < n; i++) {
        const a = (i / n) * Math.PI * 2 + R(-0.18, 0.18), isFront = Math.cos(a) > 0.55, p = R(...pr);
        let len = R(...lr); const tilt = R(...tr); let curl = R(...cr);
        if (isFront && front) { len *= front; curl *= 0.8; }
        const pivot = new THREE.Group();
        pivot.position.set(Math.sin(p) * Math.sin(a) * 0.86, 0.55 + Math.cos(p) * 0.38, Math.sin(p) * Math.cos(a) * 0.86);
        pivot.rotation.order = 'YXZ'; pivot.rotation.y = a; pivot.rotation.x = tilt;
        pivot.add(new THREE.Mesh(leafGeometry(len, R(...wr), curl, R(-0.9, 0.9)), leafMat)); head.add(pivot);
        leaves.push({ pivot, tilt, ph: rnd() * 6.28, sp: R(0.7, 1.3), amp: R(0.03, 0.07), len });
      }
    }
    ring(9, [0, 0.3], [1.15, 1.55], [0.2, 0.26], [0.1, 0.4], [0.8, 1.6], 0.8);
    ring(18, [0.35, 0.6], [1.6, 2.2], [0.22, 0.28], [0.6, 0.9], [1.8, 2.8], 0.55);
    ring(24, [0.62, 0.95], [1.8, 2.5], [0.2, 0.26], [1.0, 1.35], [2.6, 3.6], 0.42);

    const resize = () => { fit(); const s = box.clientWidth; if (s) renderer.setSize(s, s, false); };
    new ResizeObserver(resize).observe(art); resize();

    const aim = { x: 0, y: 0 }, cur = { x: 0, y: 0 }; let lastMove = 0;
    addEventListener('pointermove', e => {
      const r = box.getBoundingClientRect();
      aim.x = Math.max(-1, Math.min(1, (e.clientX - (r.left + r.width / 2)) / (innerWidth / 2)));
      aim.y = Math.max(-1, Math.min(1, (e.clientY - (r.top + r.height / 2)) / (innerHeight / 2)));
      lastMove = performance.now();
    }, { passive: true });
    const clock = new THREE.Clock();
    let boing = -10, blinkAt = 1.5, blinkT = -1, visible = true;
    box.addEventListener('pointerdown', () => { boing = clock.elapsedTime; });
    new IntersectionObserver(([en]) => { visible = en.isIntersecting; }).observe(box);

    function frame() {
      const dt = Math.min(clock.getDelta(), 0.05), tt = clock.elapsedTime;
      if (performance.now() - lastMove > 3000) { aim.x = Math.sin(tt * 0.35) * 0.35; aim.y = Math.sin(tt * 0.23) * 0.15; }
      const k = 1 - Math.exp(-dt * 7); cur.x += (aim.x - cur.x) * k; cur.y += (aim.y - cur.y) * k;
      head.rotation.y = cur.x * 0.42; head.rotation.x = cur.y * 0.22;
      eyes.forEach(g => { g.position.x = Math.sign(g.position.x) * 0.33 + cur.x * 0.05; g.position.y = -0.02 - cur.y * 0.04; });
      const br = Math.sin(tt * 1.6) * 0.012, bt = tt - boing;
      let sy = 1 + br, sx = 1 - br * 0.5, jump = 0, flare = 0, isHappy = false;
      if (bt >= 0 && bt < 1.1) {
        const d = Math.exp(-bt * 4.2), w = Math.cos(bt * 15);
        sy += -0.13 * d * w; sx += 0.09 * d * w;
        jump = Math.max(0, Math.sin(Math.min(bt / 0.45, 1) * Math.PI)) * 0.35; flare = d; isHappy = bt < 0.95;
      }
      buddy.scale.set(sx, sy, sx); buddy.position.y = jump;
      happy.forEach(h => h.visible = isHappy); eyes.forEach(g => g.visible = !isHappy);
      if (tt > blinkAt && blinkT < 0) { blinkT = tt; blinkAt = tt + 2.5 + Math.random() * 3; }
      if (blinkT >= 0) { const b = (tt - blinkT) / 0.16; const s = b < 1 ? 1 - Math.sin(b * Math.PI) * 0.92 : 1; eyes.forEach(g => g.scale.y = s); if (b >= 1) blinkT = -1; }
      for (const L of leaves) {
        L.pivot.rotation.x = L.tilt + Math.sin(tt * L.sp + L.ph) * L.amp + flare * 0.22 * (L.len / 2);
        L.pivot.rotation.z = Math.sin(tt * L.sp * 0.8 + L.ph * 1.7) * L.amp * 0.6;
      }
      effect.render(scene, camera);
    }
    // הדמות המצוירת נעלמת רק אחרי שהתלת־ממד מוכן
    frame();
    svg.querySelector('.aqc-stage') && (svg.querySelector('.aqc-stage').style.visibility = 'hidden');
    if (reduce) new ResizeObserver(() => frame()).observe(art);
    else renderer.setAnimationLoop(() => { if (visible && !document.hidden) frame(); });
    
  };

  const io = new IntersectionObserver(([en]) => { if (en.isIntersecting) { io.disconnect(); start(); } }, { rootMargin: '400px' });
  io.observe(art);
})();
